import Vue from 'vue';
import App from './App.vue';
import VueScrollTo from 'vue-scrollto';
import VueMeta from 'vue-meta';
import { router } from './router';
import store from './store';
import localforage from 'localforage';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration, CaptureConsole } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';

if (process.env.VUE_APP_SENTRY_KEY && process.env.VUE_APP_MODE) {
	Sentry.init({
		dsn: process.env.VUE_APP_SENTRY_KEY,
		environment: process.env.VUE_APP_MODE,
		release: process.env.PACKAGE_NAME + '@' + process.env.PACKAGE_VERSION,
		integrations: [
			new VueIntegration({
				Vue,
				tracing: true,
				logErrors: true,
			}),
			new Integrations.BrowserTracing(),
			new CaptureConsole({
				levels: ['error'],
			}),
		],
		tracesSampleRate: 1,
	});
} else {
	console.error('No Sentry key environment variable or env mode environment variable.');
}

if (process.env.VUE_APP_MODE === 'production') {
	console.log = function() {};
}

// this SW works only with IndexedDB
localforage.setDriver(localforage.INDEXEDDB);

// helpers functions
window.unaccent = function(s) {
	let r = s.toLowerCase();
	r = r.replace(new RegExp('\\s', 'g'), '');
	r = r.replace(new RegExp('[àáâãäåą]', 'g'), 'a');
	r = r.replace(new RegExp('æ', 'g'), 'ae');
	r = r.replace(new RegExp('ç', 'g'), 'c');
	r = r.replace(new RegExp('[èéêëę]', 'g'), 'e');
	r = r.replace(new RegExp('[ìíîï]', 'g'), 'i');
	r = r.replace(new RegExp('ñń', 'g'), 'n');
	r = r.replace(new RegExp('ł', 'g'), 'l');
	r = r.replace(new RegExp('[òóôõö]', 'g'), 'o');
	r = r.replace(new RegExp('œ', 'g'), 'oe');
	r = r.replace(new RegExp('[ùúûü]', 'g'), 'u');
	r = r.replace(new RegExp('[ýÿ]', 'g'), 'y');
	r = r.replace(new RegExp('\\W', 'g'), '');
	return r;
};

//  register service worker
if ('serviceWorker' in navigator) {
	// register service worker
	if ('serviceWorker' in navigator) {
		if (process.env.VUE_APP_MODE !== 'development') {
			navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`).then((reg) => {
				reg.onupdatefound = () => {
					const installingWorker = reg.installing;
					installingWorker.onstatechange = () => {
						if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
							window.location.reload();
						}
					};
				};
			});
		}
	}
	// add event listeners for SW
	navigator.serviceWorker.addEventListener('message', (event) => {
		switch (event.data.status) {
			case 'delivered-send':
				// store.dispatch('addNotification', {
				//     type: 'success',
				//     title: 'Potwierdzenie wysłania',
				//     content: 'Potwierdzenie zostało wysłane na serwer'
				// })
				// hide modal
				store.dispatch('hideModal');
				store.dispatch('fetchDeliveries');
				break;
		}
	});
}

require('./styles/main.sass');

Vue.config.productionTip = false;

Vue.use(VueScrollTo);

Vue.use(VueMeta, {
	// optional pluginOptions
	refreshOnceOnNavigation: true,
});

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
